export default {
	"planDispatch": {
		"mapPlanning": "地图规划",
		"addRoute": "追加运单",
		"IdlingRate": "空驶率",
		"pPunctuality": "准时率",
		"confirmScheduling": "确认调度",
		"autoLine": "自动线路规划",
		"operatingTips": "操作提示",
		"onlyOneRouter": "只能选择一条派车单记录"
	},
	"transportOrderInfo": {
		"needDelivery": "需要送货"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/planDispatch/planDispatch.js